<template>
  <div class="name">
    <Navbar />
    <div class="">
      <div class="blog-header py-4 mt-sm-4 mt-md-5">
        <div class="kovatek-blog container">
          <div
            class="blog-header-title px-3 mx-md-4 mx-md-3 px-sm-3 px-sm-0 pt-4"
          >
            <h1 class="font-weight-lighter text-white text-left mt-5">
              TalentAlt Blog
            </h1>
            <p class="text-left text-white font-weight-lighter">
              TalentAlt Blog provides quick accessibility to technological
              update, tutorials and resources that add unmeasurable value to
              developers, entrepreneurs, and designers.
            </p>
          </div>
          <div class="blog-header-share"></div>
          <div class="blog-header-search px-3 mx-md-4 mx-md-3 px-sm-3 px-sm-0">
            <div class="input-group mt-sm-4 mt-md-5 mb-3">
              <div class="input-group-prepend">
                <button class="blog-search-btn" type="button">
                  <a-icon type="search" style="color: #fff;" />
                </button>
              </div>
              <input
                type="text"
                class="form-control blog-search-input"
                placeholder="What are you looking for?"
              />
              <div class="input-group-append">
                <button class="blog-search-ok" type="submit">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-topics container">
        <div class="row px-2 px-sm-2 px-md-4 mt-4 mb-5">
          <div class="col-6 col-md-4">
            <div
              class="border text-left px-3 px-sm-2 px-md-4 mt-4 blog-main"
              @mouseover="showMore = 'Read Engineering articles'"
              @mouseleave="
                showMore =
                  'Explore in-depth developer tutorials and new technology announcements created by professional engineers in TalentAlt network'
              "
            >
              <div class="mt-4">
                <a-icon class="icon-ctrl" type="tool" />
              </div>
              <h2 class="font-weight-lighter my-4 blog-main-title">
                Engineering
              </h2>
              <p class="font-weight-lighter mt-4 mb-5 blog-main-text">
                {{ showMore }}
              </p>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div
              class="border text-left px-3 px-sm-2 px-md-4 mt-4 blog-main"
              @mouseover="showProducts = 'Read Products articles'"
              @mouseleave="
                showProducts =
                  'Your source for cutting-edge research and writing on the practice of Product Management, ranging from rapid prototyping to advanced pricing models and more'
              "
            >
              <div class="mt-4">
                <a-icon class="icon-ctrl" type="area-chart" />
              </div>
              <h2 class="font-weight-lighter my-4 blog-main-title">
                Products
              </h2>
              <p class="font-weight-lighter mt-4 mb-5 blog-main-text">
                {{ showProducts }}
              </p>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div
              class="border text-left px-3 px-sm-2 px-md-4 mt-4 blog-main"
              @mouseover="showInsights = 'Read TalentAlt Insights articles'"
              @mouseleave="
                showInsights =
                  'Explore research and expert analysis on the Future of Work, with articles on workplace efficiency and innovation'
              "
            >
              <div class="mt-4">
                <a-icon class="icon-ctrl" type="bulb" />
              </div>
              <h2 class="font-weight-lighter my-4 blog-main-title">
                TalentAlt Insight
              </h2>
              <p class="font-weight-lighter mt-4 mb-5 blog-main-text">
                {{ showInsights }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-signup blob-signup-bg">
        <div class="py-5 container">
          <div class="row px-2 px-sm-3 px-md-4 my-5">
            <div class="col-sm-12 col-md-6 px-4">
              <h3 class="font-weight-lighter text-white text-left">
                Subscribe to our weekly articles.
              </h3>
            </div>
            <div class="col-sm-12 col-md-6 px-4 text-left">
              <div class="form-group">
                <input
                  type="text"
                  class="blog-signup-input"
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group">
                <button class="blog-signup-btn">Sign me up</button>
              </div>
              <p class="text-light">
                Subscription implies consent to our <a>privacy policy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-topics container">
        <div class="row px-2 px-sm-3 px-md-4 mt-4 mb-5">
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4">
            <router-link to="/blog/create-your-own-programming-language">
              <div class="border text-left mt-4 blog-content">
                <div class="">
                  <img
                    src="../assets/KOVATEK/IMAGES/kovatek-web.png"
                    class="w-100"
                  />
                </div>
                <div class="px-4">
                  <!-- <div class=""></div> -->
                  <p
                    class="font-weight-lighter mt-4 blog-content-scope kovatek-text text-uppercase"
                  >
                    Engineering <a-icon type="right" /> Technology
                  </p>
                  <h4
                    class="text-capitalize blog-content-title font-weight-bolder"
                  >
                    Stork: How to make a programming language in C++
                  </h4>
                  <p>
                    by
                    <span class="font-weight-bolder text-uppercase"
                      >Mike. P</span
                    >
                  </p>
                  <p class="font-weight-lighter mt-4 mb-5 blog-content-text">
                    Did you ever consider creating your very own programming
                    language, either as a result of necessity or professional
                    curiosity? take the very first step toward creating a
                    lightweigh scripting language written in C++.
                  </p>
                </div>
                <p class="text-uppercase ml-4">11 minutes read</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="mt-4 mb-5">
          <a-pagination
            showQuickJumper
            :defaultCurrent="2"
            :total="500"
            @change="onChange"
          />
        </div>
      </div>
      <div class="blog-signup">
        <div class="blob-signup-bg py-5 container-fluid">
          <div class="row px-2 px-sm-3 px-md-4 my-5">
            <div class="col-sm-12 col-md-6 px-4">
              <h3 class="font-weight-lighter text-white text-left">
                World-class articles, delivered weekly.
              </h3>
            </div>
            <div class="col-sm-12 col-md-6 px-4 text-left">
              <div class="form-group">
                <input
                  type="text"
                  class="blog-signup-input"
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group">
                <button class="blog-signup-btn">Sign me up</button>
              </div>
              <p class="text-light">
                Subscription implies consent to our <a>privacy policy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GetHired />
    <Footer />
  </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import GetHired from '@/components/GetHired.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'blog',
  components: {
    Navbar,
    Footer,
    GetHired,
  },
  data() {
    return {
      showMore:
        'Explore in-depth developer tutorials and new technology announcements created by professional engineers in TalentAlt network',
      showDesign:
        'Explore advanced design topics ranging from detailed design tutorials to comprehensive coverage of new design techniques and technologies',
      showFinance:
        'Your hub for cutting-edge finance studies and analysis, including innovative strategies on raising capital and a new finance trends and tech',
      showProjects:
        'A focal point for current best practices tricks of the trade, and state knowledge in Project Management and Agile leadership',
      showProducts:
        'Your source for cutting-edge research and writing on the practice of Product Management, ranging from rapid prototyping to advanced pricing models and more',
      showInsights:
        'Explore research and expert analysis on the Future of Work, with articles on workplace efficiency and innovation',
      pageNumber: 0,
    };
  },
  methods: {
    onChange(pageNumber) {
      // console.log('Page: ', pageNumber);
      this.pageNumber = pageNumber;
    },
  },
  mounted: {
    display: function(content) {
      // if(this.showMore){
      // alert();
      let element = document.querySelector('.blog-main-text');
      element.innerHTML = content;
      // }else{
      // alert("out");
      // }
    },
  },
};
</script>

<style scoped>
p {
  color: #444444;
}
.kovatek-text {
  color: #20409a;
}
.blog-header {
  background-image: url('../assets/KOVATEK/IMAGES/image-020.png');
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}
.blog-header-title {
  width: 500px;
}
.blog-search-btn {
  background: transparent;
  border: solid 1px #fff;
  outline: 0;
  border-right: 0;
  width: 50px;
  font-size: 18px;
}
.blog-search-input {
  background: transparent;
  border: solid 1px #fff;
  border-left: 0;
  outline: 0;
  color: #fff;
  height: 50px;
  border-radius: 0;
}
.blog-search-input::placeholder {
  font-size: 22px;
  color: #fff;
}
.blog-search-ok {
  background: #fff;
  border: solid 1px #fff;
  outline: 0;
  border-left: 0;
  width: 70px;
  font-size: 14px;
}
.icon-ctrl {
  font-size: 28px;
  color: #20409a;
}
.blog-main {
  height: 280px;
  background-color: #fafafa;
}
.blog-main:hover {
  background-color: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}
.blog-main:hover .blog-main-title {
  color: #20409a;
}
.blog-main:hover .blog-main-text {
  color: #20409a;
  margin-top: 100px !important;
}
.blob-signup-bg {
  background-color: #20409a;
}
.blog-signup-input {
  background: #fff;
  border: 0;
  outline: 0;
  color: #000;
  height: 40px;
  border-radius: 0;
  padding-left: 10px;
  width: 400px;
}
.blog-signup-btn {
  background-color: #00b373;
  border: 0;
  outline: 0;
  color: #fff;
  height: 40px;
  border-radius: 0;
  padding-left: 10px;
  width: 150px;
}
.blog-signup-btn:hover {
  background-color: #06885a;
}
.blog-content {
  height: 600px;
}
.blog-content-scope {
  font-size: 11px;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .blog-main {
    height: 135px;
  }
  .blog-main h2 {
    font-size: 22px;
  }
  .blog-main p {
    display: none;
  }
  .blog-signup-input {
    width: 100%;
  }
  .blog-signup-btn {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .blog-header-title {
    width: 90%;
  }
  .blog-header-title h1 {
    font-size: 28px;
  }
  .blog-header-title p {
    display: none;
  }
  .blog-signup-input {
    width: 100%;
    margin-top: 30px;
  }
  .blog-signup-btn {
    width: 100%;
  }
  .blog-main {
    height: 135px;
  }
  .blog-main h2 {
    font-size: 22px;
  }
  .blog-main p {
    display: none;
  }
}
@media screen and (max-width: 540px) {
  .blog-main h2 {
    font-size: 18px;
  }
  .blog-search-input::placeholder {
    font-size: 16px;
  }
}
</style>
